export const SIZE_ICON = 8

export const SIZE_DESCRIPTION_LONG = 500
